import {Injectable} from '@angular/core';
import {DimensionsService} from '../../services/dimensions.service';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {Actions, createEffect, CreateEffectMetadata, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {
  loadGeneralDimensions,
  loadGeneralDimensionsSuccess,
  loadPublicGeneralDimensions,
  loadPublicGeneralDimensionsSuccess,
  updateGeneralDimensions,
  updateGeneralDimensionsSuccess
} from './generalDimensions.actions';
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {GeneralDimension} from '../../interfaces/dimensions';
import {map} from 'rxjs/operators';
import {TypedAction} from '@ngrx/store/src/models';
import {selectSite} from '../init/init.selectors';
import {Site} from '../../interfaces/site';
import {PublicReportsService} from '../../services/public-reports.service';

@Injectable()
export class GeneralDimensionsEffects {

  private readonly _load$: Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> & CreateEffectMetadata = createEffect((): Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> => this._actions$.pipe(
    ofType(loadGeneralDimensions),
    withLatestFrom(this._store.select(selectSite)),
    switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<SerializerResponse<Serializers<GeneralDimension>>> => this._dimensionsService.getGeneralDimensions(dataset)),
    map((response: SerializerResponse<Serializers<GeneralDimension>>) => loadGeneralDimensionsSuccess({
      dimensions: response.data
    }))
  ));

  private readonly _updates$: Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> & CreateEffectMetadata = createEffect((): Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> => this._actions$.pipe(
    ofType(updateGeneralDimensions),
    withLatestFrom(this._store.select(selectSite)),
    switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<SerializerResponse<Serializers<GeneralDimension>>> => this._dimensionsService.getGeneralDimensions(dataset)),
    map((response: SerializerResponse<Serializers<GeneralDimension>>) => updateGeneralDimensionsSuccess({
      dimensions: response.data
    }))
  ));

  private readonly _loadPublic$: Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> & CreateEffectMetadata = createEffect((): Observable<TypedAction<string> & { dimensions: Serializers<GeneralDimension> }> => this._actions$.pipe(
    ofType(loadPublicGeneralDimensions),
    switchMap((action: TypedAction<string> & { uuid: string, token: string }): Observable<SerializerResponse<Serializers<GeneralDimension>>> => this._publicService.getGeneralDimensions(action.uuid, action.token)),
    map((response: SerializerResponse<Serializers<GeneralDimension>>) => loadPublicGeneralDimensionsSuccess({
      dimensions: response.data
    }))
  ));

  constructor(
    private readonly _actions$: Actions,
    private readonly _store: Store<AppState>,
    private readonly _dimensionsService: DimensionsService,
    private readonly _publicService: PublicReportsService
  ) {}

}
